import React from 'react'
import styled from 'styled-components'
import {
  useBasketItemList,
  useConfigState,
  useUIFunctions,
  useGlobalLabels,
} from '@sentecacommerce-theme/lib'

import { Modal, ModalProps } from '../../../Common'
import { ProductPreview } from './Components'

export const CheckoutPreviewModal = () => {
  const { lineItems, isLoading } = useBasketItemList()
  const { closeViewById } = useUIFunctions()
  const config = useConfigState()
  const { basketPreview } = useGlobalLabels()
  return (
    <Modal
      open
      handleClose={() => closeViewById(config.views.checkoutBasketPreview)}
      title={basketPreview}
      fullOnMobile
    >
      <List>
        {!isLoading && (
          <>
            {lineItems?.map((item) => {
              return <ProductPreview item={item} key={`Product__${item._id}`} />
            })}
          </>
        )}
      </List>
    </Modal>
  )
}

type CheckoutPreviewModal = {} & ModalProps

const List = styled.ul`
  list-style: none;
`
